import { AudioDevicePreferences, PhoneNumberPreferences } from "@/enums/preferences";
import { validateWithSchema } from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import {
  type AudioDeviceResponse,
  type EmailTypeResponse,
  EmailTypeResponseSchema,
  type PhoneNumberResponse,
  PhoneNumberResponseSchema,
  type PhoneProviderResponse,
  PhoneProviderResponseSchema,
  type UpdateAudioDevicePayload,
  type UpdateEmailTypePayload,
  type UpdatePhoneNumberRoutingPayload,
} from "@/models/preferences";
import { AudioDeviceResponseSchema } from "@/schemas/communication";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { IUser } from "@/models/users";

class MyApiService {
  async getOrganizationUsers() {
    const response = await axiosClient.get<{ data: IUser[] }>(
      formatString(endpoints.MY.ORGANIZATION_USERS)
    );
    return response.data.data;
  }
  async savePreferences(
    payload:
      | UpdateEmailTypePayload
      | UpdatePhoneNumberRoutingPayload
      | UpdateAudioDevicePayload
  ) {
    const response = await axiosClient.put<{
      data:
        | EmailTypeResponse
        | PhoneNumberResponse
        | PhoneProviderResponse
        | AudioDeviceResponse;
    }>(formatString(endpoints.MY.PREFERENCES), payload);
    if (response?.data?.data?.key === PhoneNumberPreferences.routing) {
      return validateWithSchema(PhoneNumberResponseSchema, response.data.data);
    }
    if (response?.data?.data?.key === PhoneNumberPreferences.provider) {
      return validateWithSchema(
        PhoneProviderResponseSchema,
        response.data.data
      );
    }
    if (
      response?.data?.data?.key === AudioDevicePreferences.input ||
      response?.data?.data?.key === AudioDevicePreferences.output
    ) {
      return validateWithSchema(
        AudioDeviceResponseSchema,
        response.data.data
      );
    }
    return validateWithSchema(EmailTypeResponseSchema, response.data.data);
  }
}

const myApiService = new MyApiService();
export default myApiService;
